import { Zap } from 'lucide-react';

// The "badged" requirement from the "Zmist runs on Zmist" roadmap item
// (docs/CLAUDE_ZMIST_ROADMAP.md, "#status"/"#engineering" section) and the
// generic "Powered by Zmist" line item #11 tracks for public share views.
// #11 owns making this conditionally removable per the paying owner's
// `entitlements.badgeRemovable` (see frontend/src/types.ts's
// TierCatalogEntry/BillingState) - that entitlement field exists today but
// nothing renders a badge for it to gate. This component is the badge
// itself; it always renders unconditionally until #11 wires the
// removability check in on top.
export function PoweredByZmistBadge() {
  return (
    <a
      href="https://zmist.co"
      target="_blank"
      rel="noreferrer"
      className="inline-flex items-center gap-1.5 rounded-full border border-black/10 dark:border-white/15 bg-white/70 dark:bg-white/[0.06] px-3 py-1 text-xs font-medium text-black/60 dark:text-white/60 hover:text-black/80 dark:hover:text-white/80 transition-colors no-underline"
    >
      <Zap size={12} />
      Powered by Zmist
    </a>
  );
}
